import api from '../../../../api/client';

export const GROUP_OPTIONS = [
  { value: 'All', label: 'All Groups' },
  { value: '1 st and 3rd Saturday', label: '1 st and 3rd Saturday' },
  { value: 'Full Week Off', label: 'Full Week Off' },
  { value: '2nd & 4th Saturday Off', label: '2nd & 4th Saturday Off' },
  { value: 'Monday Holiday Group', label: 'Monday Holiday Group' },
];

export const HOLIDAY_TYPE_OPTIONS = [
  { value: 'All', label: 'All Types' },
  { value: 'National Holiday', label: 'National Holiday' },
  { value: 'Public Holiday', label: 'Public Holiday' },
  { value: 'Restricted Holiday', label: 'Restricted Holiday' },
];

export const YEAR_OPTIONS = [
  { value: 'All', label: 'All Years' },
  { value: '2026', label: '2026' },
  { value: '2027', label: '2027' },
];

export const holidayApi = {
  getList: async (params = {}) => {
    try {
      const response = await api.get('/self-service/holiday/', { params });
      return { data: response.data.items || [] };
    } catch (err) {
      console.warn('Failed to fetch holidays from server:', err);
      return { data: [] };
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/self-service/holiday/${id}`);
      return { data: response.data };
    } catch (err) {
      console.warn(`Failed to fetch holiday #${id}:`, err);
      return { data: null };
    }
  },

  create: async (data) => {
    const response = await api.post('/self-service/holiday/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/self-service/holiday/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/self-service/holiday/${id}`);
    return response.data;
  },
};
